import React from "react";

const Attendance = () => {
  return (
    <div className="container mt-4">
      <h4>Attendance</h4>

      {/* Summary */}
      <div className="row mb-3">
        {["Present","Late","Absent"].map((t,i) => (
          <div key={i} className="col-md-3">
            <div className="card p-3 text-center">
              <h6>{t}</h6>
              <strong>{i * 10}</strong>
            </div>
          </div>
        ))}
      </div>

      <div className="card p-3">
        <table className="table">
          <thead>
            <tr>
              <th>Employee</th>
              <th>Status</th>
              <th>Check In</th>
              <th>Check Out</th>
            </tr>
          </thead>

          <tbody>
            {[1,2,3].map(i => (
              <tr key={i}>
                <td>Antony</td>
                <td><span className="badge bg-success">Present</span></td>
                <td>09:00</td>
                <td>06:00</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Attendance;